/** @jsx jsx */
import { jsx, Box, Flex, Heading } from 'theme-ui'
import ContentfulRichText from '../shared/Contentful/RichText'
import Button from '../../components/shared/Buttons/Button'

import Img from 'gatsby-image'
import Body from '../shared/Typography/Body/Body'
import { BLOCKS } from '@contentful/rich-text-types'

const Text = ({ children }) => (
  <Body
    variant="body2"
    sx={{
      my: [0, null, '15px'],
      // mt: [0, null, '15px'],
      fontSize: [1, 2, '18px'],
    }}
  >
    {children}
  </Body>
)

const HeadingText = ({ children }) => (
  <Heading
    as="h4"
    sx={{
      my: [0, 0, 0, '15px'],
      // mt: [0, null, '15px'],
    }}
  >
    {children}
  </Heading>
)

const options = {
  [BLOCKS.PARAGRAPH]: (node, children) => <Text>{children}</Text>,
  [BLOCKS.HEADING_4]: (node, children) => <HeadingText>{children}</HeadingText>,
}

const SideBySide = props => {
  return (
    <Flex
      sx={{
        flexWrap: 'wrap',
        width: '100%',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: props.reverse ? 'row-reverse' : 'row',
        p: [0, null, null, null, '4rem'],
      }}
    >
      <Flex
        sx={{
          width: ['100%', '100%', '100%', '50%'],
          flexDirection: 'column',
          justifyContent: 'center',
          p: ['2rem', '1rem', '1rem', '4rem'],
          pt: ['2em', 0, 0, '4em'],

          textAlign: props.textAlign || 'center',
          alignItems:
            props.textAlign === 'left'
              ? 'flex-start'
              : props.textAlign === 'right'
              ? 'flex-end'
              : 'center',
        }}
      >
        <ContentfulRichText customOptions={options} text={props.text} />
      </Flex>

      <Flex
        sx={{
          width: ['100%', '100%', '100%', '50%'],
          justifyContent: 'center',
        }}
      >
        <Img
          sx={{
            margin: 'auto',
            maxHeight: props.fullHeightImage ? '70vh' : '70vh',
            width: '100%',
          }}
          fluid={props.image.fluid}
          alt={props.title}
        />
      </Flex>
    </Flex>
  )
}

export default SideBySide
